import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap';
import { Router } from '@angular/router';


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private modalService: BsModalService,
    private router:Router) { }

  modalRef: BsModalRef;
  modalRef1: BsModalRef;

   modelTitle:any
   filetype:any;


  ngOnInit() {
  }

  
 
  openModal(template: TemplateRef<any>) {
  
  const config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-xl',
    ignoreBackdropClick: true,
    initialState: {
      data1: 'new-user',
      username: 'test'
    }
  };
    this.modalRef = this.modalService.show(template, config);
   // this.modalRef = this.modalService.show(template, { class: 'modal-xl' },config);
  
  }

 

  decline(event): void {
  
    this.modalRef.hide();
  }

  policy()
  {
    debugger;
    console.log(window.location.host)
    const url=window.location.protocol+'//'+window.location.host+'/privacypolicy';
    window.open(url, '_blank');
    //this.router.navigate(['/PrivacyPolicy'])
  }

}
